import React from 'react';
import { Navigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useSettings } from '../context/SettingsContext';

/**
 * Render `children` only if the named module is enabled in admin settings.
 * If disabled, redirect to "/". Default = enabled (when flag missing).
 */
const ModuleGuard = ({ name, children }) => {
  const settings = useSettings();
  const mods = settings?.modules || {};
  // Wait for public settings to load before deciding — prevents a flash-redirect
  // for modules whose default flag is false (e.g. cab_booking).
  if (!settings?._loaded) {
    return (
      <div className="flex items-center justify-center min-h-[60vh] text-tp-violet">
        <Loader2 className="animate-spin" size={28} />
      </div>
    );
  }
  if (mods[name] === false) return <Navigate to="/" replace />;
  return children;
};

export default ModuleGuard;
